export const msgBoxId = 'carbon-ai-msg-box';
export const cacheKey = {
  SuggestionType: 'SuggestionType',
};
